export const GA = {
    // eslint-disable-next-line no-undef
    MEASUREMENT_ID: process.env.REACT_APP_GA_MEASUREMENT_ID,
};
